import React from 'react';
import { OrderedListContentfulModel } from 'src/api/models/OrderedList';
import OrderedListSection from 'src/organisms/mightyPro/OrderedListSection';

export default function getDynamicOrderedListSection(orderedListProps: OrderedListContentfulModel): React.ReactNode {
  return <OrderedListSection title={orderedListProps.title} items={orderedListProps.items} />
}
